import countryList from "react-select-country-list";

const countries = countryList().getData();

const labelToIso = new Map();
const valueToIso = new Map();

countries.forEach(({ value, label }) => {
  valueToIso.set(value.toLowerCase(), value);
  labelToIso.set(label.toLowerCase(), value);
});

/** Common aliases not matching select-country-list labels exactly. */
const ALIASES = {
  usa: "US",
  us: "US",
  "united states of america": "US",
  uk: "GB",
  "great britain": "GB",
  england: "GB",
  uae: "AE",
  "united arab emirates": "AE",
  drc: "CD",
  "democratic republic of the congo": "CD",
  "south korea": "KR",
  "north korea": "KP",
  "côte d'ivoire": "CI",
  "cote d'ivoire": "CI",
  "ivory coast": "CI",
};

export function getCountryIsoCode(countryName) {
  if (!countryName || typeof countryName !== "string") return null;

  const normalized = countryName.trim().toLowerCase();
  if (!normalized) return null;

  return (
    labelToIso.get(normalized) ||
    valueToIso.get(normalized) ||
    ALIASES[normalized] ||
    null
  );
}

export function getCountryFlagUrl(countryName, width = 40) {
  const iso = getCountryIsoCode(countryName);
  if (!iso) return null;
  return `https://flagcdn.com/w${width}/${iso.toLowerCase()}.png`;
}

export function getCountryFlagEmoji(countryName) {
  const iso = getCountryIsoCode(countryName);
  if (!iso || iso.length !== 2) return null;

  const code = iso.toUpperCase();
  return String.fromCodePoint(
    ...[...code].map((char) => 0x1f1e6 - 65 + char.charCodeAt(0))
  );
}
